import axios from 'axios'
import endpoints from '../configuration/endpoints'
import { requestShipList } from './ships'
import { requestDestinationDetails } from './destinations'
import { requestRelatedSailings } from './relatedSailings'
import fetchItinerary from './fetchItinerary'
import { setActivePackage } from './activePackage'
import { requestShipStateRooms } from './shipStateRooms'
import triggerCustomGaEvent from '../utils/triggerCustomGaEvent'
import _, { get } from 'lodash'
import formatPackage from '../utils/formatPackage'
import { addPackage } from './addPackage'
import { setInitialPackage } from './setInitialPackage'
import { setActiveSearchParameters } from './setActiveSearchParameters'
import { currencySymbol } from '../configuration/currencies'
export const SET_AGENT_DETAILS = 'SET_AGENT_DETAILS'
export const SET_PACKAGE = 'SET_PACKAGE'
export const PACKAGE_ERROR = 'PACKAGE_ERROR'
export const REQUEST_QUOTE_DETAILS = 'REQUEST_QUOTE_DETAILS'
export const RECEIVED_QUOTE_DETAILS = 'RECEIVED_QUOTE_DETAILS'
export const QUOTE_DETAILS_ERRORS = 'QUOTE_DETAILS_ERRORS'
export const AGENT_DETAILS_ERROR = 'AGENT_DETAILS_ERROR'
export const SET_AGENCY_DETAILS = 'SET_AGENCY_DETAILS'
export const SET_REFERENCE_ID = 'SET_REFERENCE_ID'

export const setAgentDetails = agency => ({
  type: SET_AGENT_DETAILS,
  payload: agency
})

const requestQuoteDetails = () => ({
  type: REQUEST_QUOTE_DETAILS
})

const receiveQuoteDetails = () => ({
  type: RECEIVED_QUOTE_DETAILS
})

export const quoteDetailsError = statusCode => ({
  type: QUOTE_DETAILS_ERRORS,
  payload: statusCode
})
const setAgencyDetails = agency => ({
  type: SET_AGENCY_DETAILS,
  payload: agency
})

export const fetchQuoteDetails = id => dispatch => {
  dispatch(requestQuoteDetails())
  dispatch({
    type: SET_REFERENCE_ID,
    payload: id
  })
  return axios
    .get(`${endpoints.quote}${id}`)
    .then(res => {
      const data = get(res, 'data.data', null)
      const packageData = get(res, 'data.package', null)
      const parameters = JSON.parse(data.parameters)

      if (data) {
        dispatch(formatAgentDetails(data))
        dispatch(setAgencyDetails(data.agency))
      } else {
        dispatch(agentDetailError())
      }
      let qualifierList = null
      let reqBody = null

      if (packageData.brand === 'Z') {
        throw new Error('deprecated')
      }

      if (data && packageData) {
        reqBody = {
          id: packageData.id,
          brand: packageData.brand,
          shipCode: packageData.shipCode,
          sailDates: packageData.relatedSailings
        }
        if (data.parameters) {
          const qualifiers = _.pick(parameters, [
            'seniorReqd',
            'policeReqd',
            'militaryReqd',
            'fireFighterReqd',
            'stateCode',
            'loyaltyId',
            'loyaltyTierCode'
          ])
          reqBody = {
            ...reqBody,
            ...qualifiers,
            currency: parameters.currency
          }
          qualifierList = qualifiers
        }

        dispatch(requestShipStateRooms(reqBody.shipCode))
        triggerCustomGaEvent('package-details', packageData)

        /*
         * There is a business rule that there is no 4th pricing for Azamara.
         * However when a quote is submitted several brands can be selected meaning
         * our occupancy may be 4 but the quote generation would have been displaying only 3rd
         * pricing for Azamara.
         * */
        const occupancy =
          packageData.brand === 'Z' &&
          parameters &&
          parameters.occupancy &&
          Number(parameters.occupancy) === 4
            ? '3'
            : parameters.occupancy

        // reqBody.occupancy = occupancy

        if (packageData.pricing) {
          const formattedCruise = formatPackage({
            ...packageData,
            occupancy,
            currency: parameters.currency,
            currencySymbol: currencySymbol[parameters.currency].symbol || '$',
            currencySymbolPlacement:
              currencySymbol[parameters.currency].placement || 'start'
          })

          dispatch(
            setActiveSearchParameters({
              ...qualifierList,
              brand: formattedCruise.brand,
              occupancy,
              currency: formattedCruise.currency,
              stateRoomSelections: formattedCruise.selections,
              equoteEmail: parameters
            })
          )
          dispatch({
            type: SET_PACKAGE,
            payload: { ...formattedCruise, qualifiers: qualifierList }
          })

          dispatch(addPackage(formattedCruise))
          dispatch(setInitialPackage(formattedCruise.identifier))
          dispatch(setActivePackage(formattedCruise.identifier))

          // Fetch the full itinerary (incl. pre/post cruisetour days) from the
          // dedicated itinerary endpoint, since the quote package only includes
          // the sailing days.
          dispatch(
            fetchItinerary({
              identifier: formattedCruise.identifier,
              packageId: packageData.id,
              brand: packageData.brand,
              sailDate: packageData.sailDate,
              startDate: packageData.startDate || packageData.sailDate,
              shipCode: packageData.shipCode,
              agencyId: data.agency.rccl_id || '',
              officeCode: parameters.officeCode || ''
            })
          )
        }
      } else {
        dispatch({
          type: PACKAGE_ERROR
        })
      }

      dispatch(receiveQuoteDetails())
      dispatch(requestShipList(packageData.shipCode))
      dispatch(requestDestinationDetails())
      dispatch(
        requestRelatedSailings({
          ...reqBody,
          sailDate: packageData.sailDate,
          agencyId: data.agency.rccl_id || '',
          officeCode: parameters.officeCode || ''
        })
      )
    })
    .catch(err => {
      if (process.env.NODE_ENV === 'development') {
        console.log(err)
      }
      if (
        (err.response &&
          err.response.status >= 400 &&
          err.response.status < 500) ||
        err.message === 'deprecated'
      ) {
        dispatch(quoteDetailsError(404))
      } else {
        dispatch(quoteDetailsError('500'))
      }
    })
}

export const formatAgentDetails = data => dispatch => {
  // AGENT AND AGENCY DETAILS
  const agent = {
    ...data.agent,
    id: data.agent_id
  }
  triggerCustomGaEvent('agent-information', data)
  dispatch(setAgentDetails(agent))
}

const agentDetailError = () => ({
  type: AGENT_DETAILS_ERROR
})
